export default "__VITE_ASSET__BsgxLoBT__"